import React, {useEffect, useMemo} from "react"
import {useFormik} from "formik"
import * as yup from "yup"
import {useDispatch, useSelector} from "react-redux"
import {login} from "../../store/appReducer"
import {Helmet} from "react-helmet-async"
import {Button, Checkbox, Form, Tag} from "antd"
import {FormInput} from "../../components/Form/FormInput"
import {StateType} from "../../store/store"
import {useHistory} from "react-router-dom"

const schema = yup.object().shape({
        email: yup.string().trim().email('Это не email').required('Введите email').max(100, 'Максимальная длина 100 символов'),
        password: yup.string().required('Введите пароль'),
})

export const Login = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const status = useSelector((state: StateType) => state.appReducer.status)
    const controller = useMemo(() => new AbortController(), [])

    useEffect(() => {
        return () => {
            controller.abort()
        }
    }, [controller])

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            pushToken: '',
            device: 'web',
            isRemaining: true,
        },
        validationSchema: schema,
        onSubmit: async (values) => {
            const {payload}: any = await dispatch(login({
                email: values.email,
                password: values.password,
                pushToken: values.pushToken,
                device: values.device,
                isRemaining: values.isRemaining,
                controller,
            }))
            if (payload) history.replace('/')
        },
    })
    const {values, handleChange, handleBlur, handleSubmit, errors, touched} = formik

    return (
        <div className="form-page" style={{height: '100%', justifyContent: 'center'}}>
            <Helmet>
                <title>Вход</title>
            </Helmet>
            <Form className="form-container"
                  style={{width: 300}}
                  onSubmitCapture={handleSubmit}
                  autoComplete='off'
            >
                <div className="description-title">Вход</div>

                <FormInput placeholder="Email"
                           value={values.email}
                           name="email"
                           onBlur={handleBlur}
                           onChange={handleChange}
                           isInvalid={touched.email && errors.email}
                           allowClear
                />
                <FormInput placeholder="Пароль"
                           value={values.password}
                           name="password"
                           onBlur={handleBlur}
                           onChange={handleChange}
                           isInvalid={touched.password && errors.password}
                           allowClear
                           isPassword
                />
                <div style={{marginTop: 20}}>
                    <Checkbox checked={values.isRemaining}
                              name="isRemaining"
                              onChange={handleChange}
                    >
                        <Tag color={values.isRemaining ? 'green' : 'default'}>Запомнить меня</Tag>
                    </Checkbox>
                </div>

                <div className="form-button-block"
                     style={{justifyContent: 'center'}}
                >
                    <Button type="primary"
                            htmlType="submit"
                            loading={status === 'loading'}
                    >
                        Вход
                    </Button>
                </div>
            </Form>
        </div>
    )
}